import { render } from "./SwiperBanner.vue?vue&type=template&id=7a9db534&scoped=true&ts=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=ts"
export * from "./SwiperBanner.vue?vue&type=script&lang=ts"

import "./SwiperBanner.vue?vue&type=style&index=0&id=7a9db534&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9db534"]])

export default __exports__